import React from 'react'
import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import trim from 'lodash/trim'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { addressShape } from '@/checkout-instore-legacy/shipping/shapes'
import { maskPostalCode } from '@/checkout-instore-legacy/shipping/utils'
import { BRAZIL_COUNTRY_CODE } from '@/checkout-instore-legacy/customer/constants'

function AddressLine({ address, withBorder, loading, onClick, countryCode }) {
  if (isEmpty(address)) {
    return null
  }

  const { postalCode, street, number, neighborhood, city, state } = address
  const formattedNumber =
    number == null || trim(number) === '' ? '' : `, ${number}`
  const formattedStreet = street ? `${street}${formattedNumber} · ` : ''
  const formattedNeighborhood = neighborhood ? `${neighborhood} · ` : ''
  const iconHeight = 16
  const iconWidth = 12
  const currentColor = loading
    ? 'mid-gray'
    : withBorder
    ? 'c-action-primary hover-c-action-primary'
    : 'c-on-base hover-mid-gray'

  const isBrazilian = countryCode === BRAZIL_COUNTRY_CODE
  const maskedPostalCode = isBrazilian
    ? maskPostalCode(postalCode, BRAZIL_COUNTRY_CODE)
    : postalCode

  return (
    <div
      className={`
        ${withBorder ? 'ba br2 b--muted-4 pv3' : ''}
        ${currentColor}
        truncate pointer
      `}
      id="address-line"
      data-cy={
        withBorder ? 'address-line-buy-component' : 'address-line-top-bar'
      }
      onClick={onClick}
    >
      <span className={`pr2 ${withBorder ? 'pl5-ns pl4' : ''}`}>
        <Icon
          type="nc-location"
          height={iconHeight}
          width={iconWidth}
          color="currentColor"
        />
      </span>
      <span className="b lh-title lh-copy-ns t-mini t-small-ns">
        {maskedPostalCode}
      </span>
      <span className="pre lh-title lh-copy-ns t-mini t-small-ns">
        {`  ·  ${formattedStreet}${formattedNeighborhood}${city} - ${state}`}
      </span>
    </div>
  )
}

AddressLine.defaultProps = {
  loading: false,
}

AddressLine.propTypes = {
  address: addressShape,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  withBorder: PropTypes.bool,
  countryCode: PropTypes.string,
  mediaQuery: PropTypes.func,
}

export default AddressLine
